document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('exhibitions-events')) return

  const sec02 = main.querySelector('.sec02')
  const archiveRoot = main.querySelector('.js_exhibition_event_archive')
  const titleEls = main.querySelectorAll('.js_exhibition_event_title')

  if (!archiveRoot) return

  const ajaxUrl =
    typeof newsAjax !== 'undefined' && newsAjax.ajax_url ? newsAjax.ajax_url : window.ajaxurl

  if (!ajaxUrl) return

  function getArchiveRoot() {
    return main.querySelector('.js_exhibition_event_archive')
  }

  function getArchiveState() {
    const root = getArchiveRoot()
    if (!root) {
      return {
        term: 'exhibitions',
        panel: 'current',
        year: '',
        paged: 1,
        lang: '',
      }
    }

    return {
      term: root.dataset.term || 'exhibitions',
      panel: root.dataset.panel || 'current',
      year: root.dataset.year || '',
      paged: parseInt(root.dataset.paged || '1', 10),
      lang: root.dataset.lang || '',
    }
  }

  function setArchiveState(nextState = {}) {
    const root = getArchiveRoot()
    if (!root) return

    if (typeof nextState.term !== 'undefined') {
      root.dataset.term = nextState.term
    }
    if (typeof nextState.panel !== 'undefined') {
      root.dataset.panel = nextState.panel
    }
    if (typeof nextState.year !== 'undefined') {
      root.dataset.year = nextState.year
    }
    if (typeof nextState.paged !== 'undefined') {
      root.dataset.paged = String(nextState.paged)
    }
    if (typeof nextState.lang !== 'undefined') {
      root.dataset.lang = nextState.lang
    }
  }

  function updateTitles(text) {
    if (!text) return
    titleEls.forEach(function (el) {
      el.textContent = text
    })
  }

  function updateParentTabs(activeTerm) {
    const tabs = main.querySelectorAll('.js_exhibition_event_tab')
    tabs.forEach(function (tab) {
      const isCurrent = tab.dataset.term === activeTerm
      tab.classList.toggle('is-current', isCurrent)
    })
  }

  function scrollToSec02() {
    if (!sec02) return

    const header = document.querySelector('header') || document.querySelector('.header')
    const headerHeight = header ? header.offsetHeight : 0
    const top = window.pageYOffset + sec02.getBoundingClientRect().top - headerHeight

    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }

  async function postAjax(action, data = {}) {
    const params = new URLSearchParams()
    params.append('action', action)

    Object.keys(data).forEach(function (key) {
      const value = typeof data[key] === 'undefined' || data[key] === null ? '' : data[key]
      params.append(key, value)
    })

    const response = await fetch(ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: params.toString(),
      credentials: 'same-origin',
    })

    if (!response.ok) {
      throw new Error('Ajax request failed.')
    }

    const json = await response.json()

    if (!json || !json.success) {
      throw new Error('Ajax response error.')
    }

    return json.data
  }

  async function loadCurrentPanel(term, shouldScroll = true) {
    const state = getArchiveState()
    const root = getArchiveRoot()
    if (!root) return

    root.classList.add('is-loading')

    try {
      const data = await postAjax('na_get_exhibition_event_current_panel', {
        term: term,
        lang: state.lang,
      })

      root.innerHTML = data.panel_html

      setArchiveState({
        term: data.term,
        panel: 'current',
        year: '',
        paged: 1,
      })

      updateTitles(data.term_label)
      updateParentTabs(data.term)

      if (shouldScroll) {
        scrollToSec02()
      }
    } catch (error) {
      console.error(error)
    } finally {
      const currentRoot = getArchiveRoot()
      if (currentRoot) {
        currentRoot.classList.remove('is-loading')
      }
    }
  }

  async function loadPastPanel(term, shouldScroll = false) {
    const state = getArchiveState()
    const root = getArchiveRoot()
    if (!root) return

    root.classList.add('is-loading')

    try {
      const data = await postAjax('na_get_exhibition_event_past_panel', {
        term: term,
        lang: state.lang,
      })

      root.innerHTML = data.panel_html

      setArchiveState({
        term: data.term,
        panel: 'past',
        year: data.year || '',
        paged: 1,
      })

      updateTitles(data.term_label)
      updateParentTabs(data.term)

      if (shouldScroll) {
        scrollToSec02()
      }
    } catch (error) {
      console.error(error)
    } finally {
      const currentRoot = getArchiveRoot()
      if (currentRoot) {
        currentRoot.classList.remove('is-loading')
      }
    }
  }

  async function loadPastArchive(term, year, paged, shouldScroll = false) {
    const state = getArchiveState()
    const pastRoot = main.querySelector('.js_exhibition_event_past_archive')
    if (!pastRoot) return

    pastRoot.classList.add('is-loading')

    try {
      const data = await postAjax('na_get_exhibition_event_past_archive', {
        term: term,
        year: year,
        paged: paged,
        lang: state.lang,
      })

      pastRoot.innerHTML = data.archive_html

      setArchiveState({
        term: data.term,
        panel: 'past',
        year: data.year || '',
        paged: data.paged || 1,
      })

      pastRoot.dataset.term = data.term
      pastRoot.dataset.year = data.year || ''
      pastRoot.dataset.paged = String(data.paged || 1)
      pastRoot.dataset.lang = state.lang

      if (shouldScroll) {
        scrollToSec02()
      }
    } catch (error) {
      console.error(error)
    } finally {
      const currentPastRoot = main.querySelector('.js_exhibition_event_past_archive')
      if (currentPastRoot) {
        currentPastRoot.classList.remove('is-loading')
      }
    }
  }

  document.addEventListener('click', function (event) {
    const parentTab = event.target.closest('.js_exhibition_event_tab')
    if (parentTab && main.contains(parentTab)) {
      event.preventDefault()

      const term = parentTab.dataset.term || 'exhibitions'
      const state = getArchiveState()

      if (state.term === term && state.panel === 'current') {
        updateParentTabs(term)
        return
      }

      loadCurrentPanel(term, true)
      return
    }

    const subTab = event.target.closest('.js_exhibition_event_sub_tab_btn')
    if (subTab && main.contains(subTab)) {
      event.preventDefault()

      const panel = subTab.dataset.panel || 'current'
      const state = getArchiveState()

      if (panel === 'current') {
        if (state.panel === 'current') return
        loadCurrentPanel(state.term, false)
        return
      }

      if (panel === 'past') {
        if (state.panel === 'past') return
        loadPastPanel(state.term, false)
      }
    }
  })

  document.addEventListener('change', function (event) {
    const yearSelect = event.target.closest('.js_exhibition_event_year')
    if (!yearSelect || !main.contains(yearSelect)) return

    const state = getArchiveState()
    const year = yearSelect.value || ''

    loadPastArchive(state.term, year, 1, false)
  })
})
